#import "../../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"
query MovementOrders($id: UUID!) {
  travelAuthorization(id: $id) {
    id
    _isTripMovementAllowed
    movementOrder {
      movementOrderNumber
      movementOrderDate

      movementTravelers(orderBy: TRAVELER_NAME_ASC) {
        nodes {
          id
          _rowTimestamp
          travelerName
          revisionReference
          entityDocumentId
          _emailDocument {
            ...EmailDocumentFields
          }
          emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
            nodes {
              ...EntityEmailDocumentsFields
            }
          }
          movementTravelerJourneys(
            orderBy: [
              JOURNEY_DATE_ASC
              JOURNEY_SECTION_ID_ASC
              JOURNEY_SEQUENCE_ASC
            ]
          ) {
            nodes {
              id
              _rowTimestamp
              _isUpdatable
              _isDeletable
              phraseType
              headerTitle
              headerCityFromTo
              bodyArea1
            }
          }
        }
      }
    }
  }
}
